
    /**
    * 供应商下拉列表
    **/
      
  import request, {AxiosPromise} from '@utils/request'
  export class IReqid18033 {}
  /**
 * YResult<YListData<BrandManageSelectorDTO>> :YResult
 */
export class IResid18033 {
  code?: {};
  msg?: {};
  success?: {};
  /**
   * YListData
   */
  data?: {
    /**
     * T
     */
    list?: {
      /**
       * 自增id
       */
      id?: {};
      /**
       * 品牌编号
       */
      brandNo?: {};
      /**
       * 供应商编号
       */
      supplierNo?: {};
      /**
       * 品牌名称
       */
      brandName?: {};
      supplierName?: {};
    }[];
    totalNumber?: {};
    rowId?: {};
  };
  exceptionMsg?: {};
}
  type Serve<T, G> = (data?: T) => AxiosPromise<G>
  const http: Serve<IReqid18033, IResid18033['data'] > = (data?) =>  request({
        method: 'GET',
        url: '/brandManage/list_supply_Selector',
        params: data
      }) 
  export default http